import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IAssessCase, IAssessCaseCreate } from '../models/assessCase';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class AssessCaseService {

    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getAssessCaseByCaseId(caseId: string): Observable<IAssessCase> {
        const url = environment.apiBaseUrl + endpoints.getAssessCaseByCaseId.replace(':caseId', caseId);
        return this.http.get<IAssessCase>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    findAssessCaseBySsid(ssid: {building_id: string, student_identifier: string}): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.getAllAssessCasesByStudentID;
        return this.http.post(url, ssid).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getBuildingAssessCases(buildingId: string): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.getAllAssessCasesByBuildingID.replace(':buildingId', buildingId);
        return this.http.get(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getHistoryByCaseId(caseId: string): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.getHistoryByCaseId.replace(':caseId', caseId);
        return this.http.get(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createNewCaseForExistingStudent(data: IAssessCaseCreate): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.createNewCaseForExistingStudent;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

}